export default __webpack_public_path__ + "static/media/cnp19_3.8c78b7e6.png";